import { useState } from 'react';
import { Mail, Send, ShieldCheck, X } from 'lucide-react';
import { api } from '../lib/api';

const jsonOptions=(method,body)=>({method,headers:{'content-type':'application/json'},body:JSON.stringify(body)});

export default function CustomerEmailVerificationModal({customerId,contact,close,onVerified}){
  const[challenge,setChallenge]=useState(null);
  const[code,setCode]=useState('');
  const[working,setWorking]=useState(false);
  const[error,setError]=useState('');
  const[notice,setNotice]=useState('');
  const endpoint=`/api/customers/${encodeURIComponent(customerId)}/contacts/${encodeURIComponent(contact.id)}/verification/email`;

  const send=async()=>{
    setWorking(true);setError('');setNotice('');
    try{
      const result=await api(endpoint+'/send',jsonOptions('POST',{}));
      if(result.alreadyVerified){
        setNotice('This email address is already verified.');
        await onVerified?.();
        return;
      }
      setChallenge(result);
      setCode('');
      setNotice(`A six-digit code was sent to ${result.maskedEmail||contact.contact_value}. It expires in 10 minutes.`);
    }catch(e){setError(e.message||'The verification code could not be sent.');}
    finally{setWorking(false);}
  };

  const verify=async event=>{
    event.preventDefault();
    if(!/^\d{6}$/.test(code)){setError('Enter the six-digit code sent to the customer.');return;}
    if(!challenge?.challengeId){setError('Send a verification code first.');return;}
    setWorking(true);setError('');
    try{
      await api(endpoint+'/verify',jsonOptions('POST',{challengeId:challenge.challengeId,code}));
      setNotice('Email address verified successfully.');
      await onVerified?.();
      close();
    }catch(e){
      setError(e.message||'The email verification code could not be confirmed.');
      setCode('');
    }finally{setWorking(false);}
  };

  return <div className="modal-backdrop" onMouseDown={event=>event.target===event.currentTarget&&!working&&close()}>
    <section className="operation-modal customer-email-verify-modal" role="dialog" aria-modal="true" aria-labelledby="customer-email-verify-title">
      <div className="modal-head"><div><span className="civ-modal-kicker">CUSTOMER INFORMATION VERIFICATION</span><h2 className="govuk-heading-m" id="customer-email-verify-title">Verify email address</h2></div><button className="icon-button" type="button" onClick={close} disabled={working}><X size={18}/></button></div>
      <div className="civ-email-summary"><Mail size={20}/><div><strong>{contact.contact_value}</strong><p className="govuk-body">A single-use six-digit code will be sent to this exact email address. Ask the customer to read the code back, then enter it here.</p></div></div>
      {error&&<div className="operation-notice error">{error}</div>}
      {notice&&<div className="operation-notice success">{notice}</div>}
      {!challenge?<div className="modal-footer"><button className="button secondary govuk-button govuk-button--secondary" type="button" onClick={close} disabled={working}>Cancel</button><button className="button primary govuk-button" type="button" onClick={send} disabled={working}><Send size={15}/>{working?'Sending…':'Send verification code'}</button></div>:<form onSubmit={verify}>
        <label className="civ-code-field govuk-label"><span>Verification code</span><input className="govuk-input" inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="[0-9]{6}" value={code} onChange={event=>setCode(event.target.value.replace(/\D/g,'').slice(0,6))} placeholder="000000" autoFocus/><small>The code expires after 10 minutes and can only be used once.</small></label>
        <div className="modal-footer"><button className="button secondary govuk-button govuk-button--secondary" type="button" onClick={send} disabled={working}>Send another code</button><button className="button primary govuk-button" type="submit" disabled={working||code.length!==6}><ShieldCheck size={15}/>{working?'Checking…':'Verify email'}</button></div>
      </form>}
    </section>
  </div>;
}
